'use es6';

import { useSelector } from 'react-redux';
import unescapedText from 'I18n/utils/unescapedText';
import { View } from 'foundations-components/components/View';
import { Flex } from 'foundations-components/components/Flex';
import { Box } from 'foundations-components/transitional/components/Box';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import { DragHandle } from 'foundations-components/transitional/components/DragHandle';
import { getMenuNode } from 'simple-menus-core/selectors/menuNode';
import { MenuNodeTypes } from '../../../constants/menus';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function OptionsPreview({
  menuNode
}) {
  let placeholderText;
  switch (menuNode.type) {
    case MenuNodeTypes.URL_LINK:
      {
        placeholderText = unescapedText(`simpleMenusLib.components.menuItemOptions.options.${MenuNodeTypes.URL_LINK}.placeholder`);
        break;
      }
    case MenuNodeTypes.PAGE_LINK:
    case MenuNodeTypes.PAGE_LINK_WITH_PARAMS:
      {
        placeholderText = unescapedText(`simpleMenusLib.components.menuItemOptions.options.${MenuNodeTypes.PAGE_LINK}.placeholder`);
        break;
      }
    case MenuNodeTypes.NO_LINK:
      {
        placeholderText = unescapedText(`simpleMenusLib.components.menuItemOptions.options.${MenuNodeTypes.NO_LINK}.placeholder`);
        break;
      }
    default:
      {
        placeholderText = null;
      }
  }
  let optionsLabel;
  switch (menuNode.type) {
    case MenuNodeTypes.URL_LINK:
      {
        optionsLabel = menuNode.linkUrl;
        break;
      }
    case MenuNodeTypes.PAGE_LINK:
    case MenuNodeTypes.PAGE_LINK_WITH_PARAMS:
      {
        optionsLabel = menuNode.pageLinkName;
        break;
      }
    case MenuNodeTypes.NO_LINK:
      {
        optionsLabel = unescapedText(`simpleMenusLib.components.menuItemOptions.options.${MenuNodeTypes.NO_LINK}.placeholder`);
        break;
      }
    default:
      {
        optionsLabel = null;
      }
  }
  if (menuNode.type === MenuNodeTypes.PAGE_LINK_WITH_PARAMS) {
    return /*#__PURE__*/_jsxs(Flex, {
      children: [/*#__PURE__*/_jsx(TextInput, {
        marginInlineEnd: "200",
        defaultValue: optionsLabel,
        placeholder: placeholderText
      }), /*#__PURE__*/_jsx(TextInput, {
        placeholder: unescapedText(`simpleMenusLib.components.menuItemOptions.options.${MenuNodeTypes.PAGE_LINK_WITH_PARAMS}.placeholder`),
        defaultValue: menuNode.linkParams
      })]
    });
  }
  return /*#__PURE__*/_jsx(TextInput, {
    marginInlineEnd: "200",
    defaultValue: optionsLabel,
    placeholder: placeholderText
  });
}
function MenuNodeItemPreview(props) {
  const menuNode = useSelector(state => getMenuNode(state, props));
  return /*#__PURE__*/_jsx(View, {
    backgroundColor: "fill-surface-default",
    borderColor: "border-core-default",
    borderStyle: "solid",
    borderWidth: "100",
    borderRadius: "100",
    marginBlockEnd: "0",
    children: /*#__PURE__*/_jsx(DragHandle, {
      position: "start",
      children: /*#__PURE__*/_jsxs(Flex, {
        "data-test-id": "menu-item",
        blockSize: "55px",
        paddingBlock: "200",
        paddingInlineStart: "600",
        paddingInlineEnd: "200",
        children: [/*#__PURE__*/_jsx(Box, {
          flex: "1 1 auto",
          paddingInlineEnd: "200",
          display: "flex",
          alignItems: "center",
          children: /*#__PURE__*/_jsx(TextInput, {
            use: "on-dark",
            defaultValue: menuNode.linkLabel,
            placeholder: unescapedText('simpleMenusLib.components.menuItemLabel.placeholder')
          })
        }), /*#__PURE__*/_jsx(Box, {
          inlineSize: "calc(50% + 68px)",
          paddingInlineStart: "200",
          display: "block",
          children: /*#__PURE__*/_jsx(Flex, {
            alignItems: "center",
            blockSize: "100%",
            children: /*#__PURE__*/_jsx(Box, {
              paddingInlineEnd: "300",
              flex: "1 0 auto",
              maxInlineSize: "calc(100% - 124px)",
              children: /*#__PURE__*/_jsx(OptionsPreview, {
                menuNode: menuNode
              })
            })
          })
        })]
      })
    })
  });
}
export default MenuNodeItemPreview;